import { Loader2 } from "lucide-react"

interface LoadingOverlayProps {
  text?: string
  className?: string
}

export function LoadingOverlay({ text = "Processing...", className = "" }: LoadingOverlayProps) {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm ${className}`}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm font-medium text-muted-foreground">{text}</p>
      </div>
    </div>
  )
}
